export enum GasPopupType {
  Popover = 'popover',
  Tooltip = 'tooltip',
}

export enum GasPopoverType {
  General = 'general',
  GeneralIcon = 'generalIcon',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Default = 'default',
}

export type GasPopupPosition = 'top' | 'top-left' | 'top-right' | 'bottom' | 'bottom-left' | 'bottom-right';

export interface PopupCoordinates {
  offsetX: number;
  yTop: number;
  yBottom: number;
  popoverWidth: number;
  popoverHeight: number;
  triggerWidth: number;
  triggerHeight: number;
}

export interface PopupSides {
  top: string;
  left: string;
}
